import styled from "styled-components";

export const StyledDiv = styled.div`
  margin-right: 1rem;
  margin-top: 0.5rem;
`;

export const StyledInput = styled.input.attrs({ type: "radio" })``;

export const StyledRadioButtonLabel = styled.label`
  margin-left: 0.1rem;
`;
